<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
    <div id="hotelList">
        <Loading v-if="show"></Loading>
        <div class="hotelList_container">
            <header class="hotel-header">
                <div class="header-left" @click="goBack">
                    <img src="../../assets/return-white.png"> 
                </div>
                <div class="header-title">
                    {{params.hotellname}}
                </div>
                <div class="header-right">
                </div>
            </header>
            <div class="hotelList_content">
                <div class="order-tips">
                    <div class="order-tip">
                        <img src="../../assets/order-tip.png">
                        预订成功后房间将为你整晚保留
                    </div>
                </div>
                <div class="order-con">
                    <div class="order-room-text">
                        <p>{{params.checkintime}}<span>共{{params.dateRange}}晚</span>{{params.checkouttime}}</p>
                        <!-- <p>大床2m | 全部房间</p> -->
                    </div>
                    <div class="order-room">
                        <div class="order-room-type">
                            {{params.showname}}
                        </div>
                        <!-- <div class="order-lunch">
                            房型餐食详情
                            <img src="../../assets/arrow-r.png"> 
                        </div> -->
                    </div>
                    <div class="order-reads">
                        <div class="order-read">
                            <div class="order-read-tit">
                                <div class="read-title">
                                    <img src="../../assets/order-danger.png">
                                    订房必读
                                </div>
                                <!-- <div class="read-more">
                                    查看更多
                                </div> -->
                            </div>
                            <div class="read-con">
                                <p v-for="(item,index) in params.hotelremark">
                                    {{item}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="order-info">
                        <div class="order-row">
                            <div class="order-label">
                                房间数
                            </div>
                            <div class="order-input">
                                <div class="room-number">
                                    <div>
                                        <input v-model="rescount" type="text" @change="regCheck2($event)"/>间 
                                    </div>
                                    <span>每间最多住2人</span>
                                </div>
                            </div>
                            <!-- <div class="order-ico" @click="getRoomList">
                                <img src="../../assets/arrow-b.png" v-if="!roomNumShow"> 
                                <img src="../../assets/arrow-t.png" v-if="roomNumShow"> 
                            </div> -->
                        </div>
                        <div class="order-row" v-if="params.hrtname=='标准间'">
                            <div class="order-label">
                                是否接受拼房
                            </div>
                            <div class="order-input">
                                <div class="room-number">
                                    <van-radio-group v-model="isSharing">
                                        <van-radio :name="1" :value="1" icon-size="16">是</van-radio>
                                        <van-radio :name="0" :value="0" icon-size="16">否</van-radio>
                                    </van-radio-group>
                                </div>
                            </div>
                        </div>
                        <div class="order-row" v-if="roomNumShow">
                            <div class="order-label">
                                
                            </div>
                            <div class="order-room">
                                <span v-for="(item,index) in roomNumList" :key='index' @click="getRoomNum($event,item.value)">
                                    {{item.number}}间
                                </span>
                            </div>
                        </div>
                        <div class="order-row">
                            <div class="order-label">
                                住客姓名
                                <img src="../../assets/wenhao.png"> 
                            </div>
                            <div class="order-input">
                                <input type="text" name="name" v-model="resname">
                            </div>
                            <div class="order-ico">
                                <img src="../../assets/person.png"> 
                            </div>
                        </div>
                        <div class="order-row">
                            <div class="order-label">
                                身份证号
                            </div>
                            <div class="order-input">
                                <input type="text" name="card"  v-model="identitycard"  @change="regCheck1(identitycard, 'ID', $event)">
                            </div>
                            <div class="order-ico">
                                <img src="../../assets/card.png"> 
                            </div>
                        </div>
                        <div class="order-row">
                            <div class="order-label">
                                大陆手机
                            </div>
                            <div class="order-tel">
                                +86
                            </div>
                            <div class="order-input">
                                <input type="text" name="tel" v-model="resphone" @change="regCheck(resphone, 'tel', $event)">
                            </div>
                            <div class="order-ico">
                                <img src="../../assets/txl.png"> 
                            </div>
                        </div>
                        <div class="order-row">
                            <div class="order-label">
                                预计到店
                            </div>
                            <div class="order-input" @click="timeArrShow">
                                <input type="text" name="date" disabled  v-model="ArrivalTime" style="width: 60px;">
                                <span>房间保留整晚</span>
                            </div>
                            <div class="order-ico" @click="getRoomList">
                                <img src="../../assets/arrow-r.png"> 
                            </div>
                        </div>
                        <div class="order-row">
                            <div class="order-label">
                                备注
                            </div>
                            <div class="order-input">
                                <input type="text" name="remark" v-model="Remark"> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loading" v-if="loading">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                </div>
            </div>
            <footer class="hotel-footer">
                <div class="footer-money">
                    订单金额
                    <span class="money">￥<i>{{totalMoney}}</i></span>
                </div>
                <div class="footer-btn">
                    <!-- <span class="mx">每晚明细</span> -->
                    <span @click="orderSubmit()">在线预订</span>
                </div>
            </footer>
            <div class="arrive-time" v-if="arrTimeShow">
                <div class="arrive-bg"></div>
                <div class="arrive-con">
                    <div class="time-list" 
                        :class="{'active':timeAct==index}"
                        v-for="(item,index) in arriveTimeArr" 
                        :key="index" 
                        @click="getArrTime($event,item,index)">
                        {{item}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Footer from '@components/Footer.vue'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
export default {
    name: 'hotelOrder',
    components: {
        Loading,
    },
    data() {
        return {
          publicSignup: {}, //通用js
          params: {
              m: '',
              hotelid: '',
              hrtname: '',
              showname: '',
              checkintime: '',
              checkouttime: '',
              dateRange: '',
              reservatcount: '',
          },
          resname: '',
          resphone: '',
          identitycard: '',
          restype: 0,
          rescount: 1,
          isSharing: 0,
          ArrivalTime: '14:00',
          Remark: '',
          meetingInfo: '',
          show: false,
          loading: false,
          navShow: true,
          navhomeUrl: '',
          roomNumShow: false,
          roomNumList: [{
            number: 1,
            value: 1
          },{
            number: 2,
            value: 2
          },{
            number: 3,
            value: 3
          }],
          timeAct: -1,
          arriveTimeArr: [],
          regTel: true,
          regCard: true,
          arrTimeShow: false,
          totalMoney: ''
        }
    },
    created() {
        this.params = this.$route.query
        this.publicSignup = new publicSignup()
        console.log(this.publicSignup)
        let opt = { m: this.params.m }
        //this.initmeeting(opt)
        if( JSON.parse(localStorage.getItem("orderInfo")) ){
            let orderInfo = JSON.parse(localStorage.getItem("orderInfo"))
            console.log(orderInfo)
            this.params = orderInfo
            document.title = orderInfo.hotellname
        }
        if( JSON.parse(localStorage.getItem("orderDetail")) ){
            let orderInfo = JSON.parse(localStorage.getItem("orderDetail"))
            console.log(orderInfo)
            this.resname = orderInfo.resname
            this.resphone = orderInfo.resphone
            this.identitycard = orderInfo.identitycard
            this.ArrivalTime = orderInfo.ArrivalTime
            this.isSharing = orderInfo.isSharing
            this.Remark = orderInfo.Remark
            this.params.hotelid = orderInfo.hid
            this.params.hotellname = orderInfo.hotellname
            this.params.checkintime = this.changeDate(orderInfo.checkintime,8)
            this.params.checkouttime = this.changeDate(orderInfo.checkouttime,8)
            this.params.dateRange = orderInfo.dateRange
            this.params.hrtname = orderInfo.hrtname
            this.params.showname = orderInfo.showname
            document.title = orderInfo.hotellname
        }
        this.HotelBookMoney()
        this.hotelInfoConfig()
    },
    mounted() {
        //this.swiperInit()
        document.title = this.params.hotellname
    },
    methods: {
        getHour(str){
            if( str > 23){
                return this.getTime(str - 24)
            }else{
                return this.getTime(str)
            }
        },
        getTime(str){
            if( str < 10){
                return '次日0'+str+':00'
            }else{
                return str+':00'
            }
        },
        //时间转换
        changeDate(date,num){
            if( date != '' && date != null && date){
                if( date.length == 16 ){
                    num = num
                }else if( date.length == 17 ){
                    num = num + 1
                }else if( date.length == 18 ){
                    num = num + 2
                }
                var dateNew = date.substring(0, num)
                return dateNew.replace(new RegExp("/","gm"),"-")
            }

        },
        // async initmeeting(opt) {
        //     this.show = true
        //     this.meetingInfo = await this.publicSignup.init(opt, this)
        //     if (this.meetingInfo.Code === 1000) {
        //         this.show = false
        //         if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
        //             this.navShow = false
        //         } else {
        //             this.navShow = true
        //             this.navhomeUrl = this.meetingInfo.HomeUrl
        //         }
        //     } else {
        //         this.$notify({
        //             massage: this.meetingInfo.Msg,
        //             type: 'danger',
        //             duration: '3000',
        //         })
        //     }
        // },
        /**
         * 获取人员报名及支付信息
         */
        async hotelInfoConfig() {
            let opts = { 
                mid: this.params.m,
            }
            try {
                let res = await this.$http.hotelInfoConfig(opts)
                console.log(res)
                if (res.Code === 1000) {
                    this.resname = res.username
                    this.resphone = res.userphone
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },
        /**
         * 订单金额
         */
        async HotelBookMoney() {
            let opts = { 
                money: this.params.money,
                checkintime: this.params.checkintime, 
                checkouttime: this.params.checkouttime,
                rescount: this.rescount,
            }
            try {
                let res = await this.$http.HotelBookMoney(opts)
                console.log(res)
                if (res.Code === 1000) {
                    this.totalMoney = res.Money
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },

        //微信分享
        async initShare(title, desc, link, imgUrl) {
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                console.log(headRes, 'headRes')
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.ready().then((wx) => {
                  _Wx.share(title, desc, link, imgUrl)
                  console.log(wx)
                })
                //this.headRess = _Wx
            } catch (err) {
                console.log(err)
            }
        },
        getRoomNum(e,num){
            this.rescount = num
            this.HotelBookMoney()
            this.roomNumShow = !this.roomNumShow
        },
        getRoomList(){
            this.roomNumShow = !this.roomNumShow
        },
        goBack(){
            this.$router.push({
                path: '/hotelDetail',
                query: {
                    m: this.params.m,
                    hotelid: this.params.hotelid
                }
            })
        },
        regCheck2(e) {
            let val = e.target.value;
            let reg = /^\d+$|^\d+[.]?\d+$/
            let reTel = reg.test(val)
            if( this.reservatcount != 0 ){
                if (reTel === false || val == 0) {
                    this.$notify({
                        message: '房间数最少为1!',
                        type: 'danger',
                    })
                    this.rescount = 1
                } else if( val > this.reservatcount){
                    this.$notify({
                        message: '可预定房间数最多为'+this.reservatcount+'!',
                        type: 'danger',
                    })
                    this.rescount = 1
                }else {
                    this.rescount = val
                } 
            }
            this.HotelBookMoney()
        },
        regCheck(val, type, event) {
            this.regTel = this.publicSignup.regCheck(val, type, event, this)
        },
        regCheck1(val, type, event) {
            this.regCard = this.publicSignup.regCheck(val, type, event, this)
        },
        timeArrShow(){
            this.arriveTimeArr = []
            var date = new Date(),
                hour = date.getHours();
            for(var i = 1; i < 13 ;i++){
                var hours = this.getHour(hour + Number(i))
                this.arriveTimeArr.push(hours);
            };
            //console.log(this.arriveTimeArr)
            this.arrTimeShow = true
        },
        getArrTime(e,val,index){
            this.timeAct = index
            this.ArrivalTime = val
            this.arrTimeShow = false
        },
        async orderSubmit(){
            if( this.resname == ''){
                this.$notify({
                    message: '姓名不能为空！',
                    type: 'danger',
                })
            }else if( this.resphone == ''){
                this.$notify({
                    message: '电话不能为空！',
                    type: 'danger',
                })
            }else if (!this.regTel) {
                this.$notify({
                    message: '请输入正确的手机号！',
                    type: 'danger',
                })
            }else if( this.identitycard == ''){
                this.$notify({
                    message: '身份证号码不能为空！',
                    type: 'danger',
                })
            }else if( !this.regCard ){
                this.$notify({
                    message: '请输入正确的身份证号码！',
                    type: 'danger',
                })
            }else if( this.ArrivalTime == ''){
                this.$notify({
                    message: '预计到店时间不能为空！',
                    type: 'danger',
                })
            }else{
                let opt = { 
                    hid: this.params.hotelid,
                    mid: this.params.m, 
                    hrtid: this.params.hrtid,
                    resname: this.resname,
                    resphone: this.resphone,
                    identitycard: this.identitycard,
                    checkintime: this.params.checkintime,
                    checkouttime: this.params.checkouttime,
                    restype: this.restype,
                    rescount: this.rescount,
                    ArrivalTime: this.ArrivalTime,
                    Remark: this.Remark,
                    hrtname: this.params.hrtname,
                    isSharing: this.isSharing
                }
                localStorage.setItem("orderDetail", JSON.stringify(opt))
                try {
                    this.loading = true
                    let res = await this.$http.hotelBook(opt)
                    console.log(res)
                    if (res.Code === 1000) {
                        this.loading = false
                        localStorage.removeItem("orderDetail")
                        this.$notify({
                            message: '预定成功',
                            type: 'primary',
                        })
                        const params = {
                            m: this.params.m,
                            hrcid: res.hrcid
                        }
                        this.$router.push({
                            path: '/hotelOrderDetail',
                            query: params,
                        })
                    } else {
                        this.$notify({
                            message: res.Msg,
                            type: 'danger',
                        })
                    }
                } catch (err) {
                    console.log(err)
                }
            }
        },
    },
}
</script>
<style lang="scss" scoped>
    .hotel-header{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 80px;
        background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%);
        display: flex;
        align-items: center;
        .header-left,
        .header-right{
            width: 100px;
            text-align: center;
            img{
                width: 40px;
                height: 40px;
            }
        }
        .header-title{
            flex: 1;
            text-align: center;
            font-size: 30px;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .hotelList_content{
        padding: 80px 0 90px;
        .order-tips{
            background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%);
            padding: 10px 20px 40px;
            color: #fff;
            .order-tip{
                display: inline-block;
                width: auto;
                padding: 5px 25px 5px 20px;
                height: 40px;
                background: rgba(255,255,255,.2);
                border-radius: 25px;
                img{
                    width: 40px;
                    height: 40px;
                    margin-right: 2px;
                }
            }
        }
        .order-con{
            background: #ffffff;
            padding: 20px 0;
            margin: -20px 0 0;
            border-radius: 30px 30px 0 0;
            .order-room{
                display: flex;
                padding: 0 20px;
                .order-room-type{
                    flex: 1;
                    font-size: 30px;
                    font-weight: bold;
                }
                .order-lunch{
                    color: rgb(29, 160, 244);
                    width: 220px;
                    text-align: right;
                    img{
                        width: 30px;
                        height: 30px;
                        vertical-align: -6px;
                    }
                }
            }
            .order-room-text{
                padding: 0 20px;
                margin-bottom: 10px;
                color: #64748b;
                font-size: 30px;
                color: #1e293b;
                span{
                    font-size: 22px;
                    margin: 0 20px;
                    border: 1px solid #e2e8f0;
                    border-radius: 20px;
                    padding: 3px 15px;
                    vertical-align: 2px;
                }
            }
        }
        .order-reads{
            background: #f8fafc;
            padding: 20px;
            margin-top: 20px;
            .order-read{
                background: #fef2f2;
                border-radius: 20px;
                padding: 20px;
                .order-read-tit{
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .read-title{
                        font-size: 28px;
                        color: #1e293b;
                        img{
                            width: 28px;
                            height: 24px;
                            vertical-align: -2px;
                        }
                    }
                    .read-more{
                        color: #3b82f6;
                    }
                }
                .read-con{
                    p{
                        padding: 5px 0;
                        color: #64748b;
                    }
                }
            }
        }
        .order-info{
            background: #ffffff;
            border-top: 1px solid #e2e8f0;
            .order-row{
                border-bottom: 1px solid #e2e8f0;
                padding: 20px;
                font-size: 26px;
                color: #64748b;
                display: flex;
                align-items: center;
                .order-label{
                    width: 160px;
                    img{
                        width: 30px;
                        height: 30px;
                        vertical-align: middle;
                    }
                }
                .order-tel{
                    width: 100px;
                    border-right: 1px solid #e2e8f0;
                }
                .order-input{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    select,
                    input{
                        width: 100%;
                        border: none;
                        height: 100%;
                        background: none;
                        padding: 0 20px;
                    }
                    span{
                        color: #64748b;
                        margin-left: 10px;
                    }
                    .room-number{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        input{
                            width: 60px;
                        }
                    }
                }
                .order-room{
                    flex: 1;
                    display: flex;
                    align-items: center;
                    span{
                        padding: 3px 20px;
                        background: #f1f5f9;
                        color: #64748b;
                        margin-right: 20px;
                    }
                }
                .order-ico{
                    width: 40px;
                    text-align: center;
                    img{
                        width: 40px;
                        height: 40px;
                    }
                }
            }
        }
    }

    .hotel-footer{
        position: fixed;
        left: 0;
        bottom: 88px;
        right: 0;
        height: 88px;
        background: #ffffff;
        display: flex;
        align-items: center;
        border-top: 1px solid #e2e8f0;
        justify-content: space-between;
        padding: 0 20px;
        .footer-money{
            color: #1e293b;
            font-size: 26px;
            .money{
                color: #e6a23c;
                padding-left: 10px;
                letter-spacing: -1px;
                i{
                    font-size: 40px;
                }
            }
        }
        .footer-btn{
            font-size: 28px;
            display: flex;
            align-items: center;
            .mx{
                font-size: 28px;
                color: #3b82f6;
                margin-right: 15px;
            }
            span:last-child{
                display: block;
                border: none;
                background: linear-gradient(135deg, #3b82f6, #6366f1);
                color: #ffffff;
                width: 130px;
                height: 50px;
                text-align: center;
                line-height: 50px;
            }
        }
    }
    .arrive-time{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 80px;
        z-index: 100;
        .arrive-bg{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 101;
            background: rgba(0,0,0,.5)
        }
        .arrive-con{
            position: absolute;
            height: 360px;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 102;
            background: #ffffff;
            display: flex;
            flex-wrap: wrap;
            padding: 10px 0;
            .time-list{
                width: calc(33.3% - 34px);
                text-align: center;
                height: 66px;
                line-height: 66px;
                background: #ffffff;
                border: 1px solid #e2e8f0;
                border-radius: 10px;
                color: #64748b;
                margin: 10px 15px;
            }
            .time-list.active{
                background: linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e5fa8 100%);
                border: 1px solid #3b82f6;
                color: #fff;
            }
        }
    }
    .van-radio-group{
        display: flex;
        div{
            margin-left: 20px;
        }
    }
</style>
<style type="text/css">
    #app{
        background: #ffffff;
    }
</style>